var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hiv-quiz',{attrs:{"question":"Everyone with HIV has AIDS","answer":false}})}
var staticRenderFns = []

export { render, staticRenderFns }